// extracted by mini-css-extract-plugin
export default {"SelectInput":"DefaultTableInput_SelectInput__+jLwd","TextInput":"DefaultTableInput_TextInput__cczS1"};